import { type LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface Props {
  label: string;
  value: string | number;
  delta?: { value: string; positive?: boolean };
  icon?: LucideIcon;
  accent?: 'primary' | 'accent' | 'emerald' | 'amber' | 'muted';
  className?: string;
}

const accents: Record<NonNullable<Props['accent']>, string> = {
  primary: 'bg-primary/10 text-primary',
  accent: 'bg-accent/10 text-accent',
  emerald: 'bg-emerald-500/10 text-emerald-600',
  amber: 'bg-amber-500/10 text-amber-600',
  muted: 'bg-muted text-muted-foreground',
};

export const StatCard = ({
  label,
  value,
  delta,
  icon: Icon,
  accent = 'primary',
  className,
}: Props) => (
  <div className={cn('rounded-2xl border border-border bg-card p-5 shadow-soft', className)}>
    <div className="flex items-start justify-between">
      <div>
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          {label}
        </p>
        <p className="mt-2 font-display text-3xl font-extrabold text-foreground">{value}</p>
        {delta && (
          <p
            className={cn(
              'mt-1 text-xs font-medium',
              delta.positive ? 'text-emerald-600' : 'text-muted-foreground'
            )}
          >
            {delta.positive ? '▲' : '▼'} {delta.value}
          </p>
        )}
      </div>
      {Icon && (
        <span className={cn('grid size-10 place-items-center rounded-xl', accents[accent])}>
          <Icon className="size-5" />
        </span>
      )}
    </div>
  </div>
);
